'use client';

import classes from "./public_provider_page.module.css"
import AuthContext from "@/providers/auth-context";
import { useContext, useEffect } from "react";
import CustomButton from "../common/buttons/button";
import Heart from '@/assets/svg/icons/heart.svg';
import useAnalyticsTracking from "../common/analytics/use_analytics_tracking";

export default function PublicProviderPageFavourite({provider, showContactMobile, compact = false}) {
    const authCtx = useContext(AuthContext);
    const { trackEvent } = useAnalyticsTracking('googleTagManager');
    const providerId = Number(provider?.id);
    const isFavourite = authCtx.tempFavouriteIds.some(id => Number(id) === providerId);

    const contactFunction = () => {
        showContactMobile();
        trackEvent('offer_request_open', {
            provider_id: provider.id,
            provider_name: provider.name,
            source: 'header'
        });

        if (window.innerWidth > 902) {
            window.scroll({behavior: 'smooth', top: 0});
        }
    }
    
    useEffect(() => {
        if(provider && provider.is_favourite) 
            {
                authCtx.setTempFavouriteIds(prev => (prev.some(id => Number(id) === providerId) ? prev : [...prev, providerId]));
                authCtx.setTempFavouriteNotes(prev => (
                    prev.find(item => Number(item.id) === providerId)
                        ? prev
                        : [...prev, {id: providerId, note: provider.favouriteNote}]
                ));
            }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provider]);

    // Kompakt nézet: csak ikonok
    if (compact) {
        return <div className="d-flex flex-row gap-1 align-items-center">
            <CustomButton 
                className={`${isFavourite ? classes["important-primary-500"] : ""}`}
                size="sm"
                hierarchy="tertiary-color" 
                icon="only" 
                is_svg={true} 
                svg={Heart} 
                onClick={() => authCtx.showFavouriteModal(providerId)}
                title="Kedvencekhez adás"
            />
            <CustomButton 
                className={`${classes["public-provider-page-contact-button"]}`} 
                size="sm"
                hierarchy="secondary-gray"
                onClick={contactFunction}
                title="Kapcsolatfelvétel"
            >
                Kapcsolatfelvétel
            </CustomButton>
        </div>
    }

    // Normál nézet: szöveges gombok
    return <div className="d-flex flex-row gap-1 align-items-center">
        <CustomButton className={`${isFavourite ? classes["important-primary-500"] : ""}`} size="lg" hierarchy="tertiary-color" icon="leading" is_svg={true} svg={Heart} onClick={() => authCtx.showFavouriteModal(providerId)} >
            Kedvencek
        </CustomButton>
        <CustomButton className={`${classes["public-provider-page-contact-button"]}`} size="md" hierarchy="primary" onClick={contactFunction} >
            Kapcsolatfelvétel
        </CustomButton>
    </div>
}